<div
  #inputGroup
  [class.form-inline]="horizontal()"
  role="group"
  [attr.aria-labelledby]="labelledBy()"
>
  @for (checkbox of checkboxObjects(); track $index) {
    <div
      class="form-check position-relative"
      [class.single-checkbox]="singleCheckbox()"
      [class.horizontal]="horizontal()"
      [class.no-label]="checkbox.label === ''"
    >
      @if (showChangeIndicatorForIds().includes(checkbox.id)) {
        <lib-dot-indicator type="checkbox" [isVisible]="true" />
      }
      <input
        [attr.tabindex]="checkAndReturnIndex($index)"
        [attr.aria-required]="requiredSignal()"
        [class]="size()"
        [class.invalid]="error()"
        (change)="updateValue($event)"
        class="form-check-input"
        type="checkbox"
        [attr.id]="'id-' + labelPrefix() + checkbox.id"
        [attr.data-value]="checkbox.id"
        [disabled]="
          extendedDisabling()
            ? disabledSignal() && !checkbox.checked
            : disabledSignal()
        "
        (focus)="onFocus($event)"
        (blur)="onBlur($event)"
        [checked]="idsArray().includes(checkbox.id)"
        [attr.aria-description]="checkbox.tooltip ?? undefined"
      />
      @if (checkbox.label !== '') {
        @if (!checkbox.tooltip) {
          <label
            [for]="'id-' + labelPrefix() + checkbox.id"
            class="form-check-label"
            [class]="size()"
            >{{ checkbox.label }}
          </label>
        } @else {
          <label
            [for]="'id-' + labelPrefix() + checkbox.id"
            class="form-check-label"
            [class]="size()"
            >{{ checkbox.label }}
            <lib-icon
              (click)="$event.preventDefault(); $event.stopPropagation()"
              tabindex="-1"
              class="checkbox-tooltip"
              name="alert-circle"
              (blur)="onBlur($event)"
              [libTooltip]="checkbox.tooltip"
              triggers="hover-persist"
            ></lib-icon>
          </label>
        }
      }
    </div>
  }
</div>
